module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet266-1200x2490.32755758.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet266-1200x2490.jpg
// module id = 1036
// module chunks = 37